import TemplateNames from '../../email-messages/TemplateNames';

export default {
  title: 'Activitate recentă',
  actions: {
    clicked: 'Accesat',
    open: 'Deschis',
    scheduled: 'Programat',
    sent: 'Trimis',
  },
  fields: {
    recipients: '{{recipients}} destinatari',
    opened: '{{rate}} deschis',
    clicked: '{{rate}} accesat',
    awaiting: 'În așteptarea confirmării',
  },
  template_types: TemplateNames,
};
